import css from 'styled-jsx/css';
import { colors, fonts, screen } from 'components/styles/variables';

export const buttonCss = css`
  .base-button {
    cursor: pointer;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-family: ${fonts.default};
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    letter-spacing: 0.2px;
    justify-content: center;
    color: ${colors.WHITE};
    background-color: ${colors.ALR1};
  }
  .base-button:hover {
    background-color: ${colors.ALR2};
    color: ${colors.WHITE};
  }
  .desktop-button {
    display: none;
  }
  .large-button {
    width: 296px;
    height: 56px;
    font-size: 18px;
  }
  .small-button {
    width: 140px;
    height: 44px;
    font-size: 16px;
  }
  .tiny-button {
    width: 140px;
    height: 36px;
    font-size: 14px;
    border-radius: 4px;
  }
  .simple-button {
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-family: ${fonts.default};
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    letter-spacing: 0.2px;
    justify-content: center;
    color: ${colors.WHITE};
    background-color: ${colors.ALR1};
  }
  .simple-button:hover {
    background-color: ${colors.ALR2};
    color: ${colors.WHITE};
  }
  .gray-button {
    color: ${colors.BLACK};
    background-color: ${colors.G1};
  }
  .gray-button:hover {
    background-color: ${colors.G2};
    color: ${colors.BLACK};
  }
  .submit-button {
    width: 100%;
    height: 44px;
  }
  .vdp-submit-button {
    width: 100%;
    height: 56px;
  }
  .save-button {
    height: 54px;
    font-size: 18px;
  }
  .contact-bar-button {
    height: 44px;
    font-size: 16px;
    flex-basis: 100%;
  }
  .loading-button {
    width: 280px;
    height: 48px;
    margin: 1px;
  }
  .disabled {
    pointer-events: none;
    opacity: 0.4;
    color: rgb(255, 255, 255);
  }
  @media (min-width: ${screen.smMin}) {
    .desktop-button {
      display: block;
    }
    .contact-bar-button {
      flex-basis: auto;
      width: 182px;
    }
  }

  @media (min-width: 850px) {
    .qc-submit-button {
      height: 56px;
    }
  }

  @media (max-width: 850px) {
    .qc-submit-button {
      height: 48px;
    }
  }
`;
